import { EventDto } from 'defs/events';
import { ProgressDataType, RootStateType } from './mySuccess';

export const getPoints = (state: RootStateType): number | null => {
	return state.mySuccess.points;
};

export const getNextLevelThreshold = (state: RootStateType): number | null => {
	return state.mySuccess.nextLevelThreshold;
};

export const getCoach = (state: RootStateType): string | null => {
	return state.mySuccess.coach;
};

export const getLevel = (state: RootStateType): string | null => {
	return state.mySuccess.level;
};

export const getAllLevels = (state: RootStateType): Array<Object> | null => {
	return state.mySuccess.allLevels;
};

export const getAllBadges = (state: RootStateType): Array<Object> => {
	return [
		...state.mySuccess.recipeBadges,
		...state.mySuccess.specialBadges,
		...state.mySuccess.tipBadges,
		...state.mySuccess.todoBadges,
		...state.mySuccess.totalNumberBadges,
		...state.mySuccess.weightBadges,
		...state.mySuccess.workoutBadges,
	];
};

export const getSpecialBadges = (state: RootStateType): Array<Object> => {
	return state.mySuccess.specialBadges || [];
};

export const getAwardedSpecialBadges = (state: RootStateType): any[] => {
	const specialBadges = getSpecialBadges(state);
	const awardedSpecialBadges = specialBadges.map((badge: any, index: number): any => {
		if (!!badge.awardedDateTime) {
			return {
				...badge,
				originalIndex: index,
			};
		}

		return void 0;
	});

	return awardedSpecialBadges.filter((item) => !!item);
};

const getMaxThresholdBadge = (badges: EventDto[]): number => {
	let maxThreshold = 0;
	badges = badges || new Array(3).fill({});

	badges.forEach((badge) => {
		const badgeIntThreashold = badge && badge.attributes ? parseInt(badge.attributes.threshold, 10) : 0;

		if (maxThreshold < badgeIntThreashold) {
			maxThreshold = badgeIntThreashold;
		}
	});

	return maxThreshold;
};

const getNextThreshold = (current: number, badges: EventDto[]): number => {
	badges = badges || new Array(3).fill({});
	let nextThreshold = 0;

	badges.forEach((badge) => {
		const badgeIntThreashold = badge && badge.attributes ? parseInt(badge.attributes.threshold, 10) : 0;

		if (badgeIntThreashold <= nextThreshold && current > badgeIntThreashold) {
			nextThreshold = badgeIntThreashold;
		}
	});

	return nextThreshold;
};

export const getProgressData = (state: RootStateType): ProgressDataType => {
	const mySuccessState = state.mySuccess;

	const total = {
		badges: mySuccessState.totalNumberBadges,
	};

	const recipes = {
		i18n: 'recipes',
		current: mySuccessState.numberOfRecipesDone || 0,
		next: mySuccessState.numberToNextRecipesBadge,
		badges: mySuccessState.recipeBadges,
		maxThreshold: 0,
	};

	recipes.maxThreshold = getMaxThresholdBadge(recipes.badges);

	const tips = {
		i18n: 'tips',
		current: mySuccessState.numberOfTipsDone || 0,
		next: mySuccessState.numberToNextTipBadge,
		badges: mySuccessState.tipBadges,
		maxThreshold: 0,
	};

	tips.maxThreshold = getMaxThresholdBadge(tips.badges);

	const todos = {
		i18n: 'todos',
		current: mySuccessState.numberOfTotalDone || 0,
		next: 1000,
		badges: mySuccessState.totalNumberBadges,
		maxThreshold: 0,
	};

	todos.next = getNextThreshold(todos.current, todos.badges);
	todos.maxThreshold = getMaxThresholdBadge(todos.badges);

	const workouts = {
		i18n: 'workouts',
		current: mySuccessState.numberOfWorkoutsDone || 0,
		next: mySuccessState.numberToNextWorkoutBadge,
		badges: mySuccessState.workoutBadges,
		maxThreshold: 0,
	};

	workouts.maxThreshold = getMaxThresholdBadge(workouts.badges);

	const tasks = {
		i18n: 'tasks',
		current: mySuccessState.numberOfTodosDone || 0,
		next: mySuccessState.numberToNextTodoBadge,
		badges: mySuccessState.todoBadges,
		maxThreshold: 0,
	};

	tasks.maxThreshold = getMaxThresholdBadge(tasks.badges);

	const thresholds = {
		nextLevel: mySuccessState.nextLevelThreshold,
		underweight: mySuccessState.underweightThreshold || 0,
	};

	const longestRun = {
		current: mySuccessState.longestRunCurrent || 0,
		record: mySuccessState.longestRunRecord || 0,
		badges: mySuccessState.longestRunBadges,
		maxThreshold: 0,
	};

	longestRun.maxThreshold = getMaxThresholdBadge(longestRun.badges);

	const weight = {
		current: mySuccessState.weightCurrent || 0,
		record: (mySuccessState as any).weightRecordDiff || 0,
		badges: mySuccessState.weightBadges,
		maxThreshold: 0,
		currentDiff: (mySuccessState as any).weightCurrentDiff || 0,
	};

	weight.maxThreshold = getMaxThresholdBadge(weight.badges);

	return {
		total,
		longestRun: longestRun as any,
		weight: weight as any,
		thresholds,
		recipes: recipes as any,
		tips: tips as any,
		todos,
		workouts: workouts as any,
		tasks: tasks as any,
	};
};
